import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CapsuleProgress from "./CapsuleProgress";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const goldCardSx = {
  p: 2,
  borderRadius: 2,
  background: "linear-gradient(135deg, #E6B65C, #FFF3C4, #D4A437)",
};

const StarBadge = () => (
  <Box
    sx={{
      width: 50,
      height: 50,
      borderRadius: "50%",
      background: "#FBC02D",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 24,
      flexShrink: 0,
    }}
  >
    ★
  </Box>
);

const NonVipMemberCard = () => (
  <Box sx={goldCardSx}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
      <StarBadge />
      <Typography fontWeight="bold" sx={{ fontSize: 18, color: "#1a1a1a" }}>
        Be A VIP Member
      </Typography>
    </Box>
    <Typography sx={{ mt: 1, color: "#1a1a1a", fontSize: 14 }}>
      Complete the below task to be a
    </Typography>
  </Box>
);

const VipMemberCard = () => (
  <Box sx={{ ...goldCardSx, pt: 4 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
      <StarBadge />
      <Typography fontWeight="bold" sx={{ fontSize: 18, color: "#1a1a1a" }}>
        VIP Member
      </Typography>
    </Box>
    <Box
      sx={{
        mt: 5,
        height: 50,
        borderRadius: 1.5,
        backgroundColor: "#fff",
        background:
          "repeating-linear-gradient(90deg, #000 0px, #000 2px, #fff 2px, #fff 6px)",
      }}
    />
  </Box>
);

const VipHeaderSection = ({
  onBack,
  progress,
  progressText,
  vipMember,
  themeColors,
}) => {
  return (
    <Box
      sx={{
        background: themeColors.mediumContainer,
        border: `1px solid ${themeColors.border}`,
        color: themeColors.text,
        borderRadius: "20px",
        p: 2,
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center">
        <Button
          onClick={onBack}
          sx={{
            color: themeColors.text,
            minWidth: "40px",
            mr: 1,
          }}
        >
          <ArrowBackIcon />
        </Button>
        <CapsuleProgress
          progress={progress}
          text={progressText}
          isVip={vipMember}
          themeColors={themeColors}
        />
      </Box>

      <Box mt={4}>
        {vipMember ? <VipMemberCard /> : <NonVipMemberCard />}
      </Box>
    </Box>
  );
};

export default VipHeaderSection;
